<template>
	<div class="filters-box">
		<div class="filters-box-row" :style="collapse ? 'height: 42px' : ''">
			<div class="data-picker-box">
				<span>下单时间：</span>
				<el-date-picker
					v-model="dateValue"
					size="small"
					type="daterange"
					:clearable='false'
					align="right"
					unlink-panels
					style="width:400px"
					range-separator="至"
					start-placeholder="开始日期"
					end-placeholder="结束日期"
					value-format="yyyy-MM-dd">
				</el-date-picker>
			</div>
			<div class="order-group-box">
				<span>客户名称：</span>
				<el-input v-model="cusname" placeholder="请输入客户名称" class="order-input" size="small" @keyup.enter.native="inputEnterHandle"></el-input>
			</div>
			<div class="order-type-box">
				<span>订单状态：</span>
				<el-select v-model="orderstatus" multiple collapse-tags placeholder="请选择订单状态" class="order-type-select" size="small">
					<!-- <el-option value="全部" label="全部"></el-option> -->
					<el-option value="待付款" label="待付款"></el-option>
					<el-option value="待接单" label="待接单"></el-option>
					<el-option value="财务审核" label="财务审核"></el-option>
					<el-option value="待发货" label="待发货"></el-option>
					<el-option value="备货中" label="备货中"></el-option>
					<el-option value="待收货" label="待收货"></el-option>
					<el-option value="已完成" label="已完成"></el-option>
					<el-option value="已取消" label="已取消"></el-option>
				</el-select>
			</div>
			<div class="order-type-box">
				<span>支付方式：</span>
				<el-select v-model="paymode" multiple collapse-tags placeholder="请选择支付方式" class="order-type-select" size="small">
					<!-- <el-option label="全部" value="全部"></el-option> -->
					<el-option label="线下支付" :value="0"></el-option>
					<el-option label="微信支付" :value="2"></el-option>
					<el-option label="预付货款支付" :value="4"></el-option>
					<el-option label="微企付支付" :value="6"></el-option>
					<el-option label="B2b门店助手-微信支付" :value="11"></el-option>
					<el-option label="B2b门店助手-银行转账" :value="12"></el-option>
					<el-option label="云资金-网商收银台" :value="13"></el-option>
					<el-option label="拉卡拉全渠道-余额支付" :value="14"></el-option>
					<el-option label="拉卡拉钱包余额" :value="16"></el-option>
					<!-- // TODO 过滤拉卡拉全渠道-收银台 -->
<!--					<el-option label="拉卡拉全渠道-收银台" :value="15"></el-option>-->
				</el-select>
			</div>
			<div class="order-NO-box">
				<span>极速订流水号：</span>
				<el-input v-model="paynumber" placeholder="请输入极速订流水号" class="order-input" size="small" @keyup.enter.native="inputEnterHandle"></el-input>
			</div>
			<div class="order-NO-box">
				<span>第三方流水号：</span>
				<el-input v-model="outpaynumber" placeholder="请输入第三方流水号" class="order-input" size="small" @keyup.enter.native="inputEnterHandle"></el-input>
			</div>
			<div class="order-NO-box">
				<span>订单编号：</span>
				<el-input v-model="ordernumber" placeholder="请输入订单编号" class="order-input" size="small" @keyup.enter.native="inputEnterHandle"></el-input>
			</div>
		</div>
		<div class="collapse-box">
			<el-button size="small" type="text" class="btn" style="color:var(--fx-primary-color);margin-left:10px" @click="handleCollapse">
				{{ collapse ? '展开' : '收起' }}
				<i class="el-icon--right" :class="collapse ? 'el-icon-arrow-down' : 'el-icon-arrow-up'" style="color:var(--fx-primary-color);"/>
			</el-button>
		</div>
	</div>
</template>
<script>
export default {
	name: 'FiltersBox',
	data () {
		return {
			dateValue: [],
			cusname: '',
			orderstatus: [],
			paymode: [],
			paynumber: '',
			outpaynumber: '',
			ordernumber: '',
			collapse: true
		}
	},
	created () {
		this.dateValue = [this.$fxUtils.getCurrentMonthFirst(), this.$fxUtils.getCurrentMonthLast()]
	},
	methods: {
		inputEnterHandle () {
			this.$emit('inputEnter')
		},
		handleCollapse () {
			this.collapse = !this.collapse
		},
		clearSearch () {
			this.dateValue = [this.$fxUtils.getCurrentMonthFirst(), this.$fxUtils.getCurrentMonthLast()]
			this.cusname = ''
			this.orderstatus = []
			this.paymode = []
			this.paynumber = ''
			this.outpaynumber = ''
			this.ordernumber = ''
		},
		getFiltersParams () {
			let filtersParams = []
			if (this.dateValue === '' ||
				this.dateValue === null ||
				this.dateValue === undefined) {
				filtersParams = [
					{ field: 'endDate', data: `${this.$fxUtils.getCurrentMonthLast()} 23:59:59`, 'op': 'le' },
					{ field: 'beginDate', data: `${this.$fxUtils.getCurrentMonthFirst()} 00:00:00`, 'op': 'ge' }
				]
			} else {
				filtersParams = [
					{ field: 'endDate', data: `${this.dateValue[1]} 23:59:59`, 'op': 'le' },
					{ field: 'beginDate', data: `${this.dateValue[0]} 00:00:00`, 'op': 'ge' }
				]
			}
			if (this.cusname) {
				let cusnameObj = { 'field': 'cusname', 'data': this.cusname, 'op': 'cn' }
				filtersParams.push(cusnameObj)
			}
			if (this.orderstatus.length !== 0) {
				let orderstatus = { 'field': 'orderstatus', 'data': this.orderstatus, 'op': 'in' }
				filtersParams.push(orderstatus)
			}
			if (this.paymode.length !== 0) {
				let paymodeObj = { 'field': 'paymode', 'data': this.paymode, 'op': 'in' }
				filtersParams.push(paymodeObj)
			}
			if (this.paynumber) {
				let paynumberObj = { 'field': 'paynumber', 'data': this.paynumber, 'op': 'cn' }
				filtersParams.push(paynumberObj)
			}

			if (this.outpaynumber) {
				let outpaynumber = { 'field': 'outpaynumber', 'data': this.outpaynumber, 'op': 'cn' }
				filtersParams.push(outpaynumber)
			}
			if (this.ordernumber) {
				let ordernumberObj = { 'field': 'ordernumber', 'data': this.ordernumber, 'op': 'cn' }
				filtersParams.push(ordernumberObj)
			}
			return {
				filtersParams
			}
		},
		getFiltersDate () {
			return [
				{ field: 'endDate', data: `${this.dateValue[1]} 23:59:59`, 'op': 'le' },
				{ field: 'beginDate', data: `${this.dateValue[0]} 00:00:00`, 'op': 'ge' }
			]
		}
	}
}
</script>
<style lang="stylus" scoped>
.filters-box {
	width:100%
	display: flex
	.filters-box-row {
		flex: 1
		display:flex
		flex-wrap: wrap
		overflow: hidden
		&>div {
			margin-bottom: 10px
			&>span {
				display: inline-block;
				width: 100px;
				text-align: right
			}
		}
		// .data-picker-box {
		// 	margin-right:10px
		// }
		.order-type-box {
			// margin-right:10px
			.order-type-select {
				width:150px
			}
		}
		.order-NO-box, .order-group-box, .order-shop-box {
			.order-input {
				width:150px
			}
		}
		// .order-group-box {
		// 	margin-right:10px
		// }
	}
	.collapse-box {
		width: 80px;
		margin-left: 10px
		flex-shrink: 0
	}
}
</style>
